import moment from 'moment'

const spendingAccountSchema = ({data, headers}) =>{
  const status = data.vendor_status
  const customer_dob = moment(data.customer_dob, 'DD-MM-YYYY').format('DD MMM YYYY')
  const appointment_date = moment(data.appointment_date).format('DD MMM YYYY')
  return (
    <tr className='text-gray-600'>
      {headers.map((key) => {
        switch (key.toUpperCase()) {
          case 'EMPLOYEE ID':
            return <td className='pl-3 pr-0 py-1'>{data.employee_id}</td>

          case 'EMPLOYEE DETAILS':
            return (
              <td className='pl-3 pr-0 py-1'>
                <p className='font-semibold mb-0 inline-block mr-2'>{data.customer_name}</p><span>| {data.customer_gender}</span><br/>
                <p className='mb-0'>{data.customer_email}</p>
                <p className=''>DOB:<span className='font-semibold text-gray-600'> {customer_dob}</span></p>
              </td>
            )
          case 'CUSTOMER TYPE':
            return (
              <td className='pl-3 pr-0 py-1'>
                <span>{data.customer_type}</span>
              </td>
            )

          case  'APPOINTMENT DATE, ID & STATUS':
            return (
              <td className='pl-3 pr-0 py-1'>
                <span>{appointment_date}</span>
                <br />
                 ID:<span className='font-semibold'> {data.unique_id} </span>
                <span className='px-2 inline-flex leading-7 font-semibold rounded-full bg-green-100 text-green-700'>  {status === 'received' ? 'completed' : status}</span>
              </td>
            )
          case 'DIAGNOSTIC CENTER':
            return (
              <td className='pl-3 pr-0 py-1'>
                <span>{data.provider_name}</span>
                ,
                <span> {data.provider_city}</span>
              </td>
            )
          case 'PACKAGE TYPE, NAME & AMOUNT':
            return (
              <td className='pl-3 pr-0 py-1'>
                <span>{data.package_type}</span>
                <br/>
                <span>{data.package_name}</span>
                <br />
                <span className='text-gray-600 font-semibold' >{data.package_mrp} </span>
              </td>
            )

          case 'RELATION':
            return (
              <td className='pl-3 pr-0 py-1'>
                <span>{data.relation}</span>
              </td>
            )

          case 'AMOUNT ALLOCATED, UTILIZED & BALANCE':
            return (
              <td className='pl-3 pr-0 py-1'>
                <p>Allocated: <span className='font-semibold text-gray-500'>{'₹'+ data.allocated_amount}</span></p>
                <p>Utilized: <span className='font-semibold text-red-500'>-{'₹'+ data.utilized_amount}</span></p>
                <p>Balance: <span className='font-semibold text-gray-500'>{'₹'+ data.balance}</span></p>
              </td>
            )
        }
      })}
    </tr>
  )
}

export default spendingAccountSchema